import logo_fi_lvv from "../../img/LVV_suomi_nega.svg";

const NewFooter = () => {
  return (
    <footer className="w-100">
      <div
        className="d-flex flex-column flex-md-row text-white pt-4 ps-md-5 ps-3 gap-4"
        style={{ backgroundColor: "var(--colors-keskivihrea, #358273)" }}
      >
        <img
          className="logo__fi"
          alt="Lupa- ja valvontavirasto"
          src={logo_fi_lvv}
        />

        <div className="d-flex flex-column">
          <p className="body-lg-bold text-white">Lisätietoja ja linkit</p>

          <p className="text-white">
            <a
              className="link-sm text-white"
              href="https://lvv.fi/tyo-raha-ja-kiinteistot/rekisteroityminen-valitysliikerekisteriin"
              style={{ marginRight: "4px" }}
            >
              Lue lisää kiinteistön tai vuokrahuoneiston välitysliikkeen
              rekisteröinnistä
            </a>
            Lupa- ja valvontaviraston sivuilta.
          </p>

          <p>
            <a className="link-sm text-white" href="https://lvv.fi/yhteystiedot">
              Yhteystiedot
            </a>
          </p>
        </div>
      </div>

      <div
        className="text-white py-3"
        style={{ backgroundColor: "var(--colors-tummansininen, #00008e)" }}
      >
        <div className="container text-center d-flex justify-content-center flex-wrap gap-3">
          <a
            className="link-sm text-white"
            href="https://lvv.fi/raha-ja-kiinteistot/valitysliikerekisterien-tietosuojaseloste"
          >
            Tietosuojaseloste
          </a>

          <span>|</span>

          <a className="link-sm text-white" href="documents/VASA_saavutettavuusseloste_LVV.html">
            Saavutettavuusseloste
          </a>

          <span>|</span>

          <a className="link-sm text-white" href="https://lvv.fi">
            © 2025 Lupa- ja valvontavirasto
          </a>
        </div>
      </div>
    </footer>
  );
};

export default NewFooter;
